import {
  DateTimeField,
  EnumField,
  LongTextField,
  RemoteDataSource,
  Required,
  Schema,
  TextField,
  Type
} from "lego-gui-lib/lib";
import { api, mainStore } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { ForeignKeyField } from "lego-gui-lib";
import { Auth } from "../../core/model/auth";
import { BooleanField } from "../../common/common";

export const PropertySchema = new Schema({
  fields: [
    {
      name: "propertyName",
      type: TextField(Required),
      title: t("common:name"),
      readonly: true
    },
    {
      name: "propertyType",
      type: PropertyTypeField(),
      title: t("common:type"),
      readonly: true
    },
    {
      name: "isList",
      type: BooleanField(Required),
      title: t("hns:property:isList"),
      readonly: true
    },
    {
      name: "description",
      type: LongTextField(),
      title: t("common:description"),
      readonly: true
    },
    {
      name: "updated",
      type: DateTimeField(),
      readonly: true,
      title: t("common:updated")
    }
  ],
  primaryKey: ["propertyName"],
  security: {
    readableRole: Auth.Roles.PLATFORM_ADMIN,
    editableRole: Auth.Roles.PLATFORM_ADMIN
  }
});

function PropertyTypeField(): Type {
  return EnumField(
    [
      { label: "string", value: "string" },
      { label: "number", value: "number" },
      { label: "json", value: "json" }
    ],
    Required
  );
}

mainStore.property = RemoteDataSource.create({
  api: api,
  name: "property",
  schema: PropertySchema,
  url: "/properties",
  commons: mainStore.commons
});

mainStore.propertyFiltered = RemoteDataSource.clone(mainStore.property, {
  params: { filters: [{ field: "isList", value: "1" }] }
});

export const PropertyFK = ForeignKeyField({
  dataSource: mainStore.propertyFiltered.listDataSource,
  labelField: "propertyName",
  valueField: "propertyName",
  minWidth: 70
});
